module.exports = __webpack_public_path__ + "img/circle.6d3463ab.svg";